import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, useContext, createContext } from "react";
import JawsClient from "./client";
export const JawsContext = createContext(null);
export const useJawsClient = () => {
    return useContext(JawsContext);
};
export const JawsClientProvider = ({ client, children }) => {
    return _jsx(JawsContext.Provider, { value: client, children: children });
};
const trueNoOp = (d) => {
    return d;
};
export const useJaws = ({ event, dataMapper = trueNoOp, shouldUpdate = trueNoOp, client = null, skip = false, }) => {
    const [state, setState] = useState(null);
    const contextClient = useJawsClient();
    const jawsClient = client || contextClient;
    const dataMapperRef = useRef(dataMapper);
    const shouldUpdateRef = useRef(shouldUpdate);
    dataMapperRef.current = dataMapper;
    shouldUpdateRef.current = shouldUpdate;
    useEffect(() => {
        if (skip || !jawsClient) {
            return () => { };
        }
        const handleEvent = (data) => {
            const mappedData = dataMapperRef.current(data);
            shouldUpdateRef.current(mappedData) && setState(mappedData);
        };
        jawsClient.on(event, handleEvent);
        return () => {
            jawsClient.off(event, handleEvent);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [event, skip]);
    return state;
};
useJaws.EVENT = JawsClient.EVENT;
export default JawsClient;
